export default function PixMethod() {
  return (
    <svg
      width='32'
      height='20'
      viewBox='0 0 32 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0 6C0 2.68629 2.68629 0 6 0H26C29.3137 0 32 2.68629 32 6V14C32 17.3137 29.3137 20 26 20H6C2.68629 20 0 17.3137 0 14V6Z'
        fill='#4DB8AA'
      />
      <path
        d='M0 6C0 2.68629 2.68629 0 6 0H26C29.3137 0 32 2.68629 32 6V14C32 17.3137 29.3137 20 26 20H6C2.68629 20 0 17.3137 0 14V6Z'
        fill='black'
        fill-opacity='0.4'
      />
      <path
        d='M11.8947 7.1579H12.9505C13.2855 7.1579 13.6068 7.29099 13.8437 7.52787L16 9.68422L18.1563 7.52787C18.3932 7.29099 18.7145 7.1579 19.0495 7.1579H20.1053M20.1053 12.8421H19.0495C18.7145 12.8421 18.3932 12.709 18.1563 12.4722L16 10.3158L13.8437 12.4722C13.6068 12.709 13.2855 12.8421 12.9505 12.8421H11.8947M18.1885 5.24113L20.7589 7.81151C21.3699 8.42253 22 9.1359 22 10C22 10.8641 21.3699 11.5775 20.7589 12.1885L18.1885 14.7589C17.5775 15.3699 16.8641 16 16 16C15.1359 16 14.4225 15.3699 13.8115 14.7589L11.2411 12.1885C10.6301 11.5775 10 10.8641 10 10C10 9.1359 10.6301 8.42253 11.2411 7.81151L13.8115 5.24113C14.4225 4.63011 15.1359 4 16 4C16.8641 4 17.5775 4.63011 18.1885 5.24113Z'
        stroke='white'
        stroke-width='1.25'
        stroke-linejoin='round'
      />
    </svg>
  );
}
